<div class="text-center mb-4">
  <h3 class="mb-4 font-weight-bold">Explore Popular Categories</h3>
  <common-top-bar-navigation [navigationItems]="renterNavigationItem" backgroundColor="" [showDesktopNavigationForMobile]="true"></common-top-bar-navigation>
</div>

<div class="row">
  <div class="col-xl-2 col-lg-3 col-md-4 col-6" *ngFor="let machine of popularMachineCategoryData">
    <a [routerLink]="machine.route" [queryParams]="machineCardParams(machine.queryParams)" class="card mb-4 cursor-pointer text-dark">
      <img class="card-img-top" [src]="machine.cardImgSrc" [alt]="machine.header" />
      <div class="card-body text-center">
        <h6 class="card-title font-weight-bold mb-0">{{ machine.header }}</h6>
        <!-- <p class="card-text text-grey font-weight-light">{{ machine.subHeader }}</p> -->
      </div>
    </a>
  </div>
</div>

<div class="text-center">
  <a class="btn btn-outline-success py-3 px-4" [routerLink]="['equipment-rentals', 'all']" [queryParams]="queryParams">{{ buttonText }}</a>
</div>
<div class="bb-light my-5"></div>
<h3 class="mb-4 font-weight-bold text-center">All Categories</h3>

<div class="card-columns">
  <div class="card border-0" [class.mb-0]="category.children?.length > 0" *ngFor="let category of allMachineCategoryData">
    <div class="d-flex align-items-center">
      <a class="text-pointer text-success fs-18 mr-2" [routerLink]="['equipment-rentals', category.name]" [queryParams]="machineCardParams()">{{
        category.name
      }}</a>
      <!-- ({{ category.count }}) -->
    </div>
    <!--<ul *ngIf="category.children?.length > 0">
      <ng-container *ngFor="let item of category.children">
        <li *ngIf="item.count > 0">
          <a class="text-pointer text-success" [routerLink]="['equipment-rentals', item.name]">{{ item.name }}</a>
        ({{ item.count }}) 
        </li>
      </ng-container>
    </ul>-->
  </div>
</div>
